// extracted by mini-css-extract-plugin
module.exports = {"alertIcon":"Ib8SuI","errorIcon":"tSEA9q"};